import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import BlogCard from '../../Blog/BlogCard';
import '../../Blog/blog.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const SkeletonCard = () => (
  <div className="blog_card blog_card--skeleton">
    <div className="blog_card__image" style={{ background: '#e2e8f0', minHeight: 200 }} />
    <div className="blog_card__content">
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <div style={{ height: 22, width: 90, borderRadius: 20, background: '#e2e8f0' }} />
        <div style={{ height: 22, width: 70, borderRadius: 20, background: '#e2e8f0' }} />
      </div>
      <div style={{ height: 22, width: '80%', borderRadius: 4, background: '#e2e8f0', marginBottom: 8 }} />
      <div style={{ height: 18, width: '95%', borderRadius: 4, background: '#e2e8f0', marginBottom: 6 }} />
      <div style={{ height: 18, width: '70%', borderRadius: 4, background: '#e2e8f0', marginBottom: 20 }} />
      <div style={{ height: 1, background: '#e2e8f0', marginBottom: 14 }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <div style={{ height: 34, width: 34, borderRadius: '50%', background: '#e2e8f0' }} />
          <div>
            <div style={{ height: 13, width: 80, borderRadius: 4, background: '#e2e8f0', marginBottom: 5 }} />
            <div style={{ height: 11, width: 60, borderRadius: 4, background: '#e2e8f0' }} />
          </div>
        </div>
        <div style={{ height: 13, width: 70, borderRadius: 4, background: '#e2e8f0' }} />
      </div>
    </div>
  </div>
);

const HomeBlogSection = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/blogs?limit=6&isActive=true&sortBy=publishedAt&order=desc`)
      .then((r) => r.json())
      .then((data) => {
        if (data.success) setBlogs(data.data || []);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (!loading && blogs.length === 0) return null;

  return (
    <section className="home_blog_section section_space" style={{ background: '#f8fafc', paddingTop: 60, paddingBottom: 60 }}>
      <div className="container">

        <div className="row justify-content-center">
          <div className="col-lg-7">
            <div className="heading_block text-center" style={{ marginBottom: 24 }}>
              <h2 className="heading_text">Latest Articles &amp; Insights</h2>
            </div>
          </div>
        </div>

        <div className="row g-4">
          {loading
            ? Array.from({ length: 6 }).map((_, i) => (
                <div className="col-lg-4 col-md-6" key={i}>
                  <SkeletonCard />
                </div>
              ))
            : blogs.map((blog) => (
                <div className="col-lg-4 col-md-6" key={blog._id}>
                  <BlogCard blog={blog} />
                </div>
              ))}
        </div>

        <div className="btns_group pb-0">
          <Link className="creative_btn" to="/blog" onClick={() => window.scrollTo(10, 0)}>
            <span className="btn_label bg-primary">View All Articles</span>
            <span className="btn_icon">
              <i className="bg-primary fa-solid fa-arrow-up-right"></i>
              <i className="bg-primary fa-solid fa-arrow-up-right"></i>
            </span>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default HomeBlogSection;
